// extracted by mini-css-extract-plugin
module.exports = {"links":"login-page_links__3ENDR"};